export const TELEPHONE_CATEGORIES = ['Лёгкие', 'Средние', 'Сложные', 'Фильмы', 'Игры', 'Сериалы'] as const;

export const CUSTOM_CATEGORY = 'Свои';

export interface TelephoneItem {
    name: string;
    category?: string;
    custom?: boolean;
    ai?: boolean;
}
